import { BrowserRouter, Routes, Route } from "react-router-dom";
// import Home from "../Components/Home";
import Navr from "../Navbar/Navr";
import Main from "../Components2/Main";
import Services from "../Components2/Services";
import Contact from "../Components2/Contact";
import Gallery from "../Components2/Gallery";
import Footer from "../Components2/Footer";
import WhatsappButton from "../Components2/WhatsappButton";

export default function Router() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navr />}>
            <Route index element={<Main />} />

          
            {/* <Route path="/Navr" element={<Navr />} /> */}
            <Route path="/Services" element={<Services />} />
            <Route path="/Contact" element={<Contact />} />
            <Route path="/Gallery" element={<Gallery />} />
            <Route path="/Footer" element={<Footer />} />

          </Route>
        </Routes>
      </BrowserRouter>
      {/* --- FLOATING WHATSAPP BUTTON --- */}
     <WhatsappButton />
    </>
  );
}
